import React from "react";
import XIconRemoveButton from "../../../components/buttons/XIconRemoveButton";

interface Props {
  airline: server.dto.Airline
  onAirlineRemoved: () => void
}

const RemovableAirline = (props: Props) => <div className="flex gap">
  <XIconRemoveButton onClick={props.onAirlineRemoved} />
  <div className="flex-column">
    <span>
      <span>{props.airline.name}</span>
      <div className="text-sublabel">{props.airline.friendlyCode}</div>
    </span>
  </div>
</div>;

export default RemovableAirline;
